/**
 * An object with string keys and values of type `any`
 */
export interface Shape {
   [key: string]: any;
}

/**
 * Predicate check that value is a function
 *
 * @param value - the value to check
 *
 */
export function isFunction(value: unknown): boolean {
   return typeof value === 'function';
}
/**
 * Predicate check that value is null
 *
 * @param value - the value to check
 *
 */
export function isNull(value: unknown): value is null {
   return value === null;
}

/**
 * Predicate check that value is undefined
 *
 * @param value - the value to check
 *
 */
export function isUndefined(value: unknown): value is undefined {
   return value === undefined;
}

/**
 * Utility predicate check that value is either null or undefined
 *
 * @param value - the value to check
 *
 */
export function isNullOrUndefined(value: unknown): value is null | undefined {
   return isNull(value) || isUndefined(value);
}

/**
 * Predicate check that value is an object.
 *
 * @param value - the value to check
 *
 */
export function isObject<Type extends Shape>(value: unknown): value is Type {
   return !isNullOrUndefined(value) && (isFunction(value) || typeof value === 'object');
}
